import DOMPurify from 'dompurify';

export const sanitizeHtml = (html) => ({ __html: DOMPurify.sanitize(html || '') });
